import  { model } from '../core/model'
import CustomDimension from '../../common/helpers/customDimension'
import CookieHelper from '../../common/helpers/cookieHelper' 
import Analitycs from './analytics'

const init = () => {
    const usuarioLogeado = !(model.Usuario.xToken) ? 'no' : 'yes';
    const payUser = !model.Usuario.hasDigitalSuscription() ? 'no' : 'yes';
    const userId = model.Usuario.UsuarioId ? model.Usuario.UsuarioId : '';
    const clubLN = model.Usuario.UsuarioDetalleClubNacion;
    const notasLeidas = CookieHelper.readCookie('countNotas');

    if (!CustomDimension.exist()) {
        CustomDimension.setRegistrado('no');
        CustomDimension.setSuscriptorType('N/A');
        CustomDimension.setUserId(userId);
        CustomDimension.save();
    }

    let CD = CustomDimension.get();

    let obj = {};
    obj.notasLeidas = notasLeidas ? notasLeidas : 0;
    obj.usuarioLogeado = usuarioLogeado;
    obj.usuarioRegistrado = CD.usuarioRegistrado;
    obj.payUser = payUser;
    obj.suscriptorType = CD.suscriptorType;
    obj.userId = CD.userId;
    obj.credentialType = clubLN ? clubLN : 'N/A';

    obj['nota-PW'] = model.Window.paginaId;
    //obj['url-nota-PW'] = model.Window.notaUrlLimpia;
    obj['url-nota-PW'] = model.Window.notaUrlLimpia;
    
    Analitycs.trackCustomDimension(obj);

}

export default init;


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/helpers/customDimension.js